import { jsx } from "react/jsx-runtime";
import styles from "./Avatar.module.scss.js";
function getInitials(name = "") {
  const initials = name.trim().split(/\s+/).map((s) => s[0].toUpperCase());
  if (initials.length < 2) {
    return initials[0] ?? "";
  }
  return initials[0] + initials[initials.length - 1];
}
function Avatar(props) {
  return props.url ? /* @__PURE__ */ jsx(
    "img",
    {
      className: styles.image,
      src: props.url,
      alt: props.name,
      width: 34,
      height: 34,
      "data-selected": props.selected
    }
  ) : /* @__PURE__ */ jsx("div", { className: styles.initials, "data-selected": props.selected, children: /* @__PURE__ */ jsx("span", { children: getInitials(props.name) }) });
}
export {
  Avatar
};
